import '@vaadin/dialog';
import { componentName, ModalClass } from './ModalClass';

customElements.define(componentName, ModalClass);

export { ModalClass, componentName };
